export const shortenId = (id: string) => {
  return id.substring(0, 8);
};
